import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropMenuModule } from '../drop-menu/drop-menu.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MediaCarouselComponent } from './media-carousel/media-carousel.component';

@NgModule({
  declarations: [MediaCarouselComponent],
  imports: [
    CommonModule,
    DropMenuModule,
    SharedModule
  ],
  exports:[MediaCarouselComponent]
})
export class MediaCarouselModule { }

// translation loader moved to SharedModule